/* Reversible hand-off and sunlight; no scroll interception. Optimized for mobile scroll. */
(() => {
 if(window.shopalScrollLightInstalled)return;
 window.shopalScrollLightInstalled=true;
 const clamp=v=>Math.max(0,Math.min(1,v));
 const smooth=v=>{v=clamp(v);return v*v*(3-2*v)};
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 let frame=0,intro=null,gallery=null,viewport=null,host=null,introParts=[];
 function addLight(parent){
  if(!parent||parent.querySelector(':scope > .sh-scroll-light'))return;
  const el=document.createElement('div');el.className='sh-scroll-light';el.setAttribute('aria-hidden','true');parent.append(el);
 }
 function refresh(){
  intro=document.querySelector('shopal-canyon.sc');
  gallery=document.querySelector('shopal-categories.sct');
  viewport=gallery?.querySelector('.sct__viewport')||null;
  host=intro?.closest('.shopal-canyon-section')||intro;
  introParts=intro?[...intro.querySelectorAll('.sc__object,.sc__word,.sc__loader')]:[];
  addLight(intro);addLight(viewport);
 }
 function paintLight(parent,p){
  if(!parent)return;
  const v=motion.matches?.5:clamp(p);
  parent.style.setProperty('--sh-ray-angle',(-18+36*v).toFixed(3)+'deg');
  parent.style.setProperty('--sh-sun-x',(43+14*v).toFixed(3)+'%');
  parent.style.setProperty('--sh-ray-shift',(-20+40*v).toFixed(3)+'px');
  parent.style.setProperty('--sh-light-opacity',(.6+.25*Math.sin(Math.PI*v)).toFixed(3));
 }
 function update(){
  frame=0;
  if(!intro&&!gallery)refresh();
  const vh=innerHeight;
  const galleryRect=gallery?.getBoundingClientRect();
  if(intro&&host){
   const rect=host.getBoundingClientRect();
   paintLight(intro,rect.top < -8 ? 1 : 0);
   const top=galleryRect?.top;
   const overlapping=host.classList.contains('has-scroll-intro')&&gallery?.classList.contains('is-scroll')&&!motion.matches;
   const presence=overlapping&&Number.isFinite(top)?1-smooth((vh-top)/(vh*.85)):1;
   intro.style.setProperty('--sh-intro-presence',presence.toFixed(4));
   const hidden=presence<.01;
   intro.classList.toggle('sh-intro-hidden',hidden);
   for(const el of introParts){
    el.inert=hidden;
    if(hidden)el.setAttribute('data-sh-hidden','true');else el.removeAttribute('data-sh-hidden');
   }
  }
  if(gallery&&viewport&&galleryRect){
   paintLight(viewport,(vh-galleryRect.top)/Math.max(1,gallery.offsetHeight));
  }
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(update)}
 function refreshAndSchedule(){refresh();schedule()}
 addEventListener('scroll',schedule,{passive:true});
 addEventListener('resize',schedule,{passive:true});
 addEventListener('pageshow',refreshAndSchedule);
 motion.addEventListener('change',schedule);
 document.addEventListener('shopify:section:load',refreshAndSchedule);
 document.addEventListener('shopify:section:unload',refreshAndSchedule);
 customElements.whenDefined('shopal-canyon').then(refreshAndSchedule);
 customElements.whenDefined('shopal-categories').then(refreshAndSchedule);
 refresh();update();
})();
